var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChainRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.854,8.854l-7,7-.707-.707,7-7,.707,.707Zm-4.561,12.384c-1.136,1.136-2.65,1.762-4.262,1.762-1.611,0-3.125-.625-4.261-1.76-1.139-1.138-1.766-2.652-1.767-4.262s.626-3.124,1.764-4.263l3.98-3.98-.707-.707-3.98,3.98C.733,13.335,.003,15.101,.003,16.978c0,1.877,.732,3.642,2.06,4.97,1.326,1.324,3.09,2.053,4.968,2.053,1.88,0,3.645-.73,4.969-2.055l3.973-3.972-.707-.707-3.973,3.972ZM21.947,2.063C20.619,.735,18.854,.003,16.978,.003,15.1,.003,13.335,.733,12.008,2.06l-3.98,3.98,.707,.707,3.98-3.98c1.139-1.138,2.652-1.764,4.263-1.764,1.609,0,3.123,.628,4.262,1.767,2.348,2.35,2.347,6.173-.002,8.523l-3.972,3.973,.707,.707,3.972-3.973c2.739-2.739,2.74-7.197,.002-9.937Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainRegular);
export default __webpack_public_path__ + "static/media/chain-regular.9639f9c5e6b23e4221fdf995cf2255eb.svg";
export { ForwardRef as ReactComponent };